import { render, staticRenderFns } from "./ElementCreator.vue?vue&type=template&id=3ab3519e"
import script from "./ElementCreator.vue?vue&type=script&lang=js"
export * from "./ElementCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports